import { render, staticRenderFns } from "./StockValuationSummary.vue?vue&type=template&id=32e460d5&"
import script from "./StockValuationSummary.vue?vue&type=script&lang=js&"
export * from "./StockValuationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports